//
// Module for Retro Pay Period Adjustment
//
rs.module("content/participant/member/retroadjustments",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls, perPayPeriodEnumValue) {

            // Unpack js selectors
            var retroAdjustmentForm = $.js(jsSelectors.retroAdjustmentForm);

            var modeSelect = retroAdjustmentForm.js(jsSelectors.modeSelect);
            var employerSelect = retroAdjustmentForm.js(jsSelectors.employerSelect);
            var lumpSumDateInput = retroAdjustmentForm.js(jsSelectors.lumpSumDateInput);

            var salaryAmountInput = retroAdjustmentForm.js(jsSelectors.salaryAmountInput);
            var payItemSelect = retroAdjustmentForm.js(jsSelectors.payItemSelect);
            var payItemSelectHelper = selectHelper.getHelper(payItemSelect);
            var contributionAmountInput = retroAdjustmentForm.js(jsSelectors.contributionAmountInput);
            var contributionTypeSelect = retroAdjustmentForm.js(jsSelectors.contributionTypeSelect);
            var contributionTypeSelectHelper = selectHelper.getHelper(contributionTypeSelect);

            var submitButton = retroAdjustmentForm.js(jsSelectors.submitButton, { required: false });
            var loadingSpinner = retroAdjustmentForm.js(jsSelectors.loadingSpinner);

            // Toggle "Remove Lump Sum From Pay Period End Date" based on Mode selection
            modeSelect.change(function () {
                var disable = this.value == perPayPeriodEnumValue;

                if (disable) {
                    lumpSumDateInput.val("").clearErrors();
                }

                lumpSumDateInput.prop("disabled", disable);
            });

            // Change Pay Items based on Employer selection
            employerSelect.change(function () {
                var employerKey = this.value;
                if (employerKey == "") {
                    payItemSelectHelper.clearOptions();
                } else {
                    payItemSelectHelper.loadOptionsFrom(
                        ajaxUrls.getPayItems,
                        {
                            employerKey: employerKey
                        },
                        {
                            withBlank: true
                        });
                }
            });

            // Toggle Pay Items based on if Salary Amount provided
            salaryAmountInput.on("input", function () {
                var disable = salaryAmountInput.val() == '';
                payItemSelectHelper.setDisabled(disable);

                if (disable) {
                    payItemSelectHelper.setValue(null);
                    payItemSelect.clearErrors();
                }
            });

            // Toggle Contribution Types based on if Contribution Amount provided
            contributionAmountInput.on("input", function () {
                var disable = contributionAmountInput.val() == '';
                contributionTypeSelectHelper.setDisabled(disable);

                if (disable) {
                    contributionTypeSelectHelper.setValue(null);
                    contributionTypeSelect.clearErrors();
                }
            });

            // show the loading spinner when loading the grid if the form is valid
            submitButton.on("click", function () {
                if (retroAdjustmentForm.valid()) {
                    loadingSpinner.show();
                }
            })
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);